import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("CalculoCorrecaoTO")
export class CalculoCorrecaoTO {

  taxa: number;

  valor: number
}
